import github from '../../assets/Outils/github.png';
import figma from '../../assets/Outils/figma.png';
import postman from '../../assets/Outils/postman.png';
import packOffice from '../../assets/Outils/packOffice.png';
import Ps from '../../assets/Outils/photoshop.png';

const docker = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg';
const trello = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/trello/trello-original.svg';
const jira = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jira/jira-original.svg';

const OutilsElements = [
  { id: 1, path: github, title: "Github", style: "shadow-orange-500" },
  { id: 2, path: figma, title: "Figma", style: "shadow-orange-500" },
  { id: 3, path: postman, title: "Postman", style: "shadow-orange-500" },
  { id: 4, path: docker, title: "Docker", style: "shadow-orange-500" },
  { id: 5, path: trello, title: "Trello", style: "shadow-orange-500" },
  { id: 6, path: jira, title: "Jira", style: "shadow-orange-500" },
  { id: 7, path: packOffice, title: "Pack Office", style: "shadow-orange-500" },
  { id: 8, path: Ps, title: "Photoshop", style: "shadow-orange-500" },
];

export default OutilsElements;
  